import React from 'react';
const DocumentsContext = React.createContext({
    documents: null,
    setDocuments: () => {}
})

export const DocumentsProvider = DocumentsContext.Provider
export default DocumentsContext;